enum PRINT_QUERIES {
    SALES_INVOICE_PRINT_QUERY = "fe1a15c8f8",
    PACKING_SLIP_PRINT_QUERY = "b56bed1dbe",
    PACKING_SLIP_PRINT_QUERY_V2 = "e2f7323b8f",
    DELIVERY_DOCUMENT_QUERY = "90445fc576"
}

export default PRINT_QUERIES